export default __webpack_public_path__ + "static/media/Outsourcing-EN.279d8f9d.png";